import * as react_components from "../reactcomponent"
import * as propertyTypes from "../property_types"
import React from "react"
var parameters = {
    "rows": [
        { "type": "ROW", "rowItems": [] }]
};

export class SqlParameter extends React.Component<any, any>{

    handleTextChange = (name, value) => {
        this.props.onTextChange(name, value);
    }

    renderParameter = (param): any => {
        if (param.Type == 0 || param.Type == 1) {
            return { uid: param.Name || kendo.guid(), type: "REACTTEXT", name: param.Name, label: param.Name, width: 2 }
        }
        return { uid: param.Name || kendo.guid(), type: "DATE", name: param.Name, label: param.Name, width: 2 }
    }

    render() {
        var parametersJson = null;
        if (Array.isArray(this.props.parameters)) {
            parametersJson = this.props.parameters.map(this.renderParameter);
        }
        parameters.rows[0].rowItems = parametersJson;
        return (
            <div>
                <div>
                    <react_components.ReactDynamicUi uiDefinition={parameters} onTextChange={this.handleTextChange} parameters={this.props.parameterValues} />
                </div>
            </div>)
    }
};


export class SqlResultTable extends React.Component<any, any>{
    private gridRef;
    private grid;

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.createGrid(this.props.data);
    }

    generateColumns = (data: any[]) => {
        let columns: any[] = [];
        if (data && data.length > 0) {
            for (var key in data[0]) {
                var value = data[0][key];
                columns.push({ field: key, title: key, width: 150 });
            }
        }
        return columns;
    }

    createGrid = (data) => {
        data = data || [];
        var that = this;
        var $rootNode = $(this.gridRef);
        let columns = this.generateColumns(data);

        var grid = $rootNode.kendoGrid({
            dataSource: {
                data: data,
                pageSize: 20
            },
            resizable: true,
            height: 550,
            sortable: true,
            pageable: {
                refresh: false,
                pageSizes: true,
                buttonCount: 5
            },
            columns: columns
        });

        this.grid = grid.data("kendoGrid");
    }

    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
        this.grid.destroy();
    }

    render() {
        var style = { width: "100%" };
        return (<div className="col-sm-12" style={{ padding: "0px" }}>
            Max 1000 results
            <div ref={(element) => { this.gridRef = element }}></div>
        </div>)
    }
};

export class SqlParameterState extends propertyTypes.Serializable {
    private NameMetadata = new propertyTypes.TextProperty("Name", "Name");
    public Name: string;

    private TypeMetadata = new propertyTypes.SelectProperty("Type", "Type")
        .addOption("0", "Number")
        .addOption("1", "String")
        .addOption("2", "Date");
    public Type; string;

    private IsArrayMetadata = new propertyTypes.CheckBoxProperty("IsArray", "Is Array");
    public IsArray: boolean;

    getMetadata(): propertyTypes.BaseProperty[] {
        return [this.NameMetadata, this.TypeMetadata, this.IsArrayMetadata];
    }
}